import {AppFlags} from '../../../app/app-types';
import {OETarget} from '../../../react-oe/oe-target';
import {OELicensingEdition} from '../../../react-oe/oe-types';
import {OEManualViewLinks, OEManualViewLinkType} from '../../views/manual-view/oe-manual-view-model';
import {OEVersionFeatureAccess, OEVersionTargetsAlphaBetaProds, OEVersionStartSelectionDataAlphaBetaProd} from '../oe-proto-model';
import {OEImplantcastTargetType as OEImplantcastTargetType_, opTargets, OEImplantcastStartSelectionContent} from './oe-implantcast-consts';

export const OEImplantcastTargetType = OEImplantcastTargetType_;

export const OEImplantcastTargets = new OEVersionTargetsAlphaBetaProds(
    {
        [OEImplantcastTargetType.anatomy]: [
            OETarget.humanAbdominalWall,
            OETarget.humanAnkleFoot,
            OETarget.humanArm,
            OETarget.humanChestWall,
            OETarget.humanForearm,
            OETarget.humanHand,
            OETarget.humanHip2,
            OETarget.humanLeg,
            OETarget.humanLowerLeg,
            OETarget.humanNeckBack,
            OETarget.humanPelvis,
            OETarget.humanShoulderGirdle,
            OETarget.humanSpine,
            OETarget.humanThighKnee,
            OETarget.humanTrunk,
            OETarget.humanUpperArmElbow,
        ],
        [OEImplantcastTargetType.op]: opTargets
    },
    {
        [OEImplantcastTargetType.anatomy]: OETarget.humanHip2,
        [OEImplantcastTargetType.op]: OETarget.implantcastEcoFitCup,
    },
    {
        [OEImplantcastTargetType.anatomy]: OETarget.humanHip2
    }
);

//
export const OEImplantcastFeatureAccess = new(class extends OEVersionFeatureAccess {

    constructor(versionTargets) {
        super(versionTargets);
    }

    initialFeatureAccess()  {
        let isLicensing = this.isLicensing();
        return Object.assign(this.createFeatureAccessObj(), {
            //anatomyModule: !isLicensing,
            //anatomyTargetSelection: !isLicensing,
        });
    }

    featureAccessForLicensingAccess(licensingAccess)    {
        if(!licensingAccess.isLicensing)    return this.createFeatureAccessObj();

        let featureAccess = this.initialFeatureAccess();

        /*
        if(licensingAccess.isValid)    {
            featureAccess.anatomyModule = true;
            featureAccess.anatomyTargetSelection = true;
        }
        */

        return featureAccess;
    }
})(OEImplantcastTargets);

//
export const OEImplantcastStartSelectionData = new OEVersionStartSelectionDataAlphaBetaProd(
    OEImplantcastTargets,
    OEImplantcastStartSelectionContent
);

//
export const OEImplantcastManual = {

    getOpManualLinks() {
        return [
            {link: OEManualViewLinks.app, type: OEManualViewLinkType.pdf, refId: 'manual_op', page: 1},
            {link: OEManualViewLinks.welcome, type: OEManualViewLinkType.pdf, refId: 'manual_op', page: 1},
            {link: OEManualViewLinks.controls, type: OEManualViewLinkType.pdf, refId: 'manual_op', page: 2},
            {link: OEManualViewLinks.functions, type: OEManualViewLinkType.pdf, refId: 'manual_op', page: 2},
            {link: OEManualViewLinks.contextMenu, type: OEManualViewLinkType.pdf, refId: 'manual_op', page: 3},
            {link: OEManualViewLinks.search, type: OEManualViewLinkType.pdf, refId: 'manual_op', page: 4},
            {link: OEManualViewLinks.component, type: OEManualViewLinkType.pdf, refId: 'manual_op', page: 5},
            {link: OEManualViewLinks.label, type: OEManualViewLinkType.pdf, refId: 'manual_op', page: 6},
            {link: OEManualViewLinks.cut, type: OEManualViewLinkType.pdf, refId: 'manual_op', page: 7},
            {link: OEManualViewLinks.mediaCenter, type: OEManualViewLinkType.pdf, refId: 'manual_op', page: 8},
            {link: OEManualViewLinks.settings, type: OEManualViewLinkType.pdf, refId: 'manual_op', page: 9}
        ];
    }
};